<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			
			<!-- 
			<Button type="info" @click="cold">冷藏/常温</Button>
			<Button type="success" @click="start">启用/禁用</Button> -->
		</div>
		
		<div  class="lb">
			
			<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
				<template slot-scope="{ row, index }" slot="action">
					
						<Button size="small" style="margin-right: 5px" @click="delete(row.id)" type="primary">删除</Button>
				</template>
			</Table>
			<div class="my-page">
				<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading: false,
				total: 100,
				query: {
					page: 0,
					size: 10
				},
				columns12: [{
						title: 'id',
						key: 'id'
					}, {
						title: '意见',
						key: 'opinion'
					},
					{
						title: '联系方式',
						key: 'contactWay'
					},
					
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [],

			}
		},
		methods: {
			
			ret() { //返回上一页
				this.$router.go(-1)
			},
			delete(id){
				
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/client/opinion/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.loading = false
						_this.total = data.opinion.totalElements
						_this.data6 = data.opinion.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		    shengchan(id){
				
			}
		},
		components: {
			page
		},
		created() {
			this.ajaxPage()
			//this.ajaxPageDitu()
			
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/clientOpinion/list.vue